import React from 'react';
import './style.scss';

const Brand = () => {
    return <div className="brand"></div>;
};

export default Brand;
